import {
  Box,
  IconPenEdit,
  Typography,
  selectTheme,
  styled,
} from '@creditas-ui/react';
import type React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useEjnSelected } from '../../../contexts/ejn';
import { addFeedback } from '../../../store/reducers/feedback';
import { invalidAddress, serializeBrAddress } from '../../../utils/helpers';
import { EditAddress } from './EditAddress';

const CurrentAddress = styled.div`
  background-color: ${selectTheme('colors.neutral.10')};
  width: 100%;
  box-sizing: border-box;
  padding: 18px 20px 18px 20px;     
`;

const IconEditAddressWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  color: ${selectTheme('colors.primary.80')};
  &:hover {
    cursor: pointer;
  }
`;

export const EnjAddress: React.FC<{
  setShowEditAddress: (value: boolean) => void;
  showEditAddress: boolean;
}> = ({ setShowEditAddress, showEditAddress }) => {
  const dispatch = useDispatch();

  const { ejn, notificationAddress, updateAddress, resetEditingAddress } =
    useEjnSelected();

  useEffect(() => {
    if (notificationAddress.success) {
      setShowEditAddress(false);
      dispatch(
        addFeedback({
          text: 'Endereço atualizado com sucesso',
          type: 'success',
        }),
      );
    }

    if (notificationAddress.error) {
      dispatch(
        addFeedback({
          text: 'Erro ao atualizar endereço',
          type: 'error',
        }),
      );
    }
  }, [notificationAddress, dispatch, setShowEditAddress]);

  const showEditAddressFn = () => {
    setShowEditAddress(true);
    resetEditingAddress();
  };

  const hideEditAddressFn = () => {
    setShowEditAddress(false);
    resetEditingAddress();
  };

  if (!ejn) {
    return (
      <Typography variant={'bodyMdRegular'} color={'neutral.80'}>
        Dados não carregados.
      </Typography>
    );
  }

  return (
    <Box>
      {showEditAddress ? (
        <EditAddress
          address={ejn.notification.address}
          onSubmmit={updateAddress}
          onCancel={hideEditAddressFn}
          loading={notificationAddress.loading}
        />
      ) : (
        <Box spaceY="1rem">
          <Typography
            variant={'bodyMdRegular'}
            color={'neutral.80'}
            margin="0 25px 0 25px"
          >
            Você está prestes a enviar uma nova tentativa de notificação para o
            contrato
            <span style={{ fontWeight: 'bold', margin: '0 5px' }}>
              #{ejn?.notification.ccn}
            </span>
            no endereço a seguir. Gostaria de prosseguir?
          </Typography>
          <CurrentAddress>
            <Typography variant={'bodyMdRegular'} color={'neutral.80'}>
              {ejn?.notification.address
                ? serializeBrAddress(ejn?.notification.address)
                : ''}
            </Typography>
            <IconEditAddressWrapper
              data-testid="close-modal"
              onClick={showEditAddressFn}
            >
              <IconPenEdit color="#23A969" size={24} />
              Alterar Endereço
            </IconEditAddressWrapper>
          </CurrentAddress>
          {invalidAddress(ejn.notification.address) && (
            <Typography
              variant={'bodySmMedium'}
              color={'error.60'}
              margin="0 25px 0 25px"
            >
              Endereço atual está incompleto, por favor ajuste antes de enviar
              uma nova notificação.
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};
